import { predictionAbi } from '../abis/prediction';
import { encodeFunctionData, PublicClient, Address } from 'viem';

export const getOptions = async (address: Address, client: PublicClient) => {
  return await client.readContract({
    address,
    abi: predictionAbi,
    functionName: 'options',
  });
};

export type GetOptionOutAmountProps = {
  address: Address; // contract address
  optionIndex: bigint; // optionsOutIndex
  tokenAmount: bigint; // baseToken amount
};

export const getOptionOutAmount = async (
  { address, optionIndex, tokenAmount }: GetOptionOutAmountProps,
  client: PublicClient
) => {
  return await client.readContract({
    address,
    abi: predictionAbi,
    functionName: 'getAmountOut',
    args: [optionIndex, tokenAmount],
  });
};

export type GetTokenOutAmountProps = {
  address: Address; // contract address
  optionsLength?: number; // options length
  optionIndex: bigint; // option Out Index
  optionAmount: bigint; // option Amount
};

export const getTokenOutAmount = async (
  { address, optionsLength, optionIndex, optionAmount }: GetTokenOutAmountProps,
  client: PublicClient
) => {
  let len = optionsLength;
  if (!len) {
    try {
      len = Number(await client.readContract({ address, abi: predictionAbi, functionName: 'MAX_OPTION' }));
    } catch {
      // PredictionCTF contracts don't have MAX_OPTION — default to binary (2)
      len = 2;
    }
  }
  const optionsAmounts: bigint[] = new Array(len).fill(BigInt(0));
  optionsAmounts[Number(optionIndex)] = optionAmount;
  return await client.readContract({
    address,
    abi: predictionAbi,
    functionName: 'getAmountsOut',
    args: [optionsAmounts],
  });
};

export type EncodeDepositProps = {
  optionIndex: bigint; // out option Index
  tokenAmount: bigint; // base token amount
  minOptionAmount: bigint; // min option Amount
  deadline: bigint; // second time
};

export const encodeDeposit = ({ optionIndex, tokenAmount, minOptionAmount, deadline }: EncodeDepositProps) => {
  return encodeFunctionData({
    abi: predictionAbi,
    functionName: 'deposit',
    args: [optionIndex, tokenAmount, minOptionAmount, deadline],
  });
};

export type EncodeWithdrawProps = {
  optionIndex: bigint; // in option Index
  optionAmount: bigint; // option Amount
  minTokenAmount: bigint; // min base token amount
  deadline: bigint; // second time
};

export const encodeWithdraw = ({ optionIndex, optionAmount, minTokenAmount, deadline }: EncodeWithdrawProps) => {
  return encodeFunctionData({
    abi: predictionAbi,
    functionName: 'withdraw',
    args: [optionIndex, optionAmount, minTokenAmount, deadline],
  });
};

export const encodeClaimAll = () => {
  return encodeFunctionData({
    abi: predictionAbi,
    functionName: 'claimAll',
  });
};
